"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var utilities_1 = require("../utilities");

var styled_1 = require("./styled");

var ParsedContent =
/** @class */
function (_super) {
  __extends(ParsedContent, _super);

  function ParsedContent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderParsedContent = function () {
      var _a = _this.props,
          content = _a.content,
          customBulletPointColor = _a.customBulletPointColor;
      var contentWithParsedHtmlChars = utilities_1.parseHtmlChars(content);
      var elements = utilities_1.parseElements(contentWithParsedHtmlChars);

      if (elements.length > 0) {
        return elements.map(function (element, index) {
          var textContent = element.textContent,
              elementType = element.elementType;
          return react_1.default.createElement(styled_1.ElementWithParsedText, {
            key: index,
            textContent: textContent,
            elementType: elementType,
            customBulletPointColor: customBulletPointColor,
            "aria-label": "Element type: " + elementType + ", Content: " + textContent
          });
        });
      }

      var parsedContent = utilities_1.parseTextStyle(contentWithParsedHtmlChars);
      return parsedContent.map(function (textNode, index) {
        var textNodeContent = textNode.textContent,
            rest = __rest(textNode, ["textContent"]);

        return react_1.default.createElement(styled_1.TextWithParsedStyles, __assign({
          key: index
        }, rest, {
          "aria-label": textNodeContent
        }), textNodeContent);
      });
    };

    return _this;
  }

  ParsedContent.prototype.render = function () {
    return react_1.default.createElement(styled_1.TextWithInheritedStyle, null, this.renderParsedContent());
  };

  return ParsedContent;
}(react_1.default.Component);

exports.ParsedContent = ParsedContent;